import { GET_SURGE_EVENTS, GET_SURGE_EVENTS_SUCCESS, GET_SURGE_EVENTS_ERROR, GET_SURGE_EVENTS_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetEvents = (state = initialState, action) => {
  switch (action.type) {
    case GET_SURGE_EVENTS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_SURGE_EVENTS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_SURGE_EVENTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_SURGE_EVENTS_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetEvents;
